<template>
  <div class="tinymce-editor">
    <editor v-model="editorValue" :init="init" @onClick="onClick" :disabled="disabled" />

    <upload-image isEditor folder="other" @postImage="postImage" />
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import uploadImage from '@/components/upload/image'

import 'tinymce/themes/silver'

import 'tinymce/plugins/lists' // 列表插件
import 'tinymce/plugins/wordcount' // 字数统计插件
import 'tinymce/plugins/paste'
import 'tinymce/icons/default'

export default {
  components: { Editor, uploadImage },

  props: {
    value: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    plugins: {
      type: [String, Array],
      default: 'lists wordcount paste'
    },

    toolbar: {
      type: [String, Array],
      default:
        'undo redo | formatselect | forecolor backcolor bold | numlist bullist | removeformat | aligncenter | indent'
    }
  },

  data() {
    return {
      init: {
        language: 'zh_CN',
        language_url: 'static/tinymce/tinymceLangs/zh_CN.js',
        skin_url: 'static/tinymce/tinymce/skins/ui/oxide',

        height: 400,
        plugins: [this.plugins],
        toolbar: this.toolbar,
        branding: false,
        menubar: false,
        paste_as_text: true, // 过滤复制
        convert_urls: false,
        selector: '#tinydemo',

        content_css: 'static/tinymce/tinymce.css'
      },

      editorValue: this.value
    }
  },

  mounted() {
    tinymce.init({})
  },

  watch: {
    value(val) {
      this.editorValue = val
    },

    editorValue(val) {
      this.$emit('listenChangeEditorValue', val)
    }
  },

  methods: {
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick(e) {
      this.$emit('onClick', e, tinymce)
    },

    postImage(url) {
      console.log('url :>> ', url)
      tinymce.execCommand(
        'mceInsertContent',
        false,
        `<img src="${process.env.VUE_APP_FILE_URL}?code=${url}">`
      )
    }
  }
}
</script>

<style>
.tinymce-editor {
  position: relative;
  width: 100%;
}
.image-upload {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

.el-popup-parent--hidden .tox-silver-sink {
  z-index: 10000;
}
</style>
